import Nav from 'ext-ui/components/Nav/Nav'
import { spacing } from 'ext-ui/style/spacing'
import { transition_slow } from 'ext-ui/style/transitionSpeeds'
import styled, { css } from 'styled-components'

export const SidenavIconLinkColumn = css`
  display: flex;
  flex-direction: column;
  padding: ${spacing(3)} 0;
  gap: ${spacing(1)};
`

export const sidenavContentContainer = css`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden auto;
`

export const sidenavTransitionContainer = css`
  position: absolute;
  width: 100%;
  height: 100%;

  /* Settings content animations */
  &.settings.sidenav-transition-enter {
    transform: translateX(100%);
  }

  &.settings.sidenav-transition-enter-active {
    transform: translateX(0);
    transition: transform ${transition_slow} ease-in-out;
  }

  &.settings.sidenav-transition-exit {
    transform: translateX(0);
  }

  &.settings.sidenav-transition-exit-active {
    transform: translateX(100%);
    transition: transform ${transition_slow} ease-in-out;
  }

  /* Main content animations */
  &.main.sidenav-transition-enter {
    transform: translateX(-100%);
  }

  &.main.sidenav-transition-enter-active {
    transform: translateX(0);
    transition: transform ${transition_slow} ease-in-out;
  }

  &.main.sidenav-transition-exit {
    transform: translateX(0);
  }

  &.main.sidenav-transition-exit-active {
    transform: translateX(-100%);
    transition: transform ${transition_slow} ease-in-out;
  }
`

export const SidenavAdsNav = styled(Nav)`
  && {
    background: transparent;
    border-right: 0;
    gap: 0;
    height: 100%;
    padding-block: 0;
    width: 100%;
  }

  &&.minimized,
  &&.not-minimized {
    align-items: stretch;
    width: 100%;
  }
`
